import ActionColumn from "./ActionColumn";

export const USER_COLUMNS = [
  {
    title: (
      <p
        style={{
          margin: 0,
          fontWeight: 600,
          fontSize: 16,
        }}
      >
        Name
      </p>
    ),
    dataIndex: "name",
    key: "name",
    width: "20%",
    sorter: (a: any, b: any) => ("" + a.name).localeCompare(b.name),
  },
  {
    title: (
      <p
        style={{
          margin: 0,
          fontWeight: 600,
          fontSize: 16,
        }}
      >
        Email
      </p>
    ),
    dataIndex: "email",
    key: "email",
    width: "35%",
    sorter: (a: any, b: any) => ("" + a.email).localeCompare(b.email),
  },
  {
    title: (
      <p
        style={{
          margin: 0,
          fontWeight: 600,
          fontSize: 16,
        }}
      >
        Permission Group
      </p>
    ),
    dataIndex: "permissionGroup",
    key: "permissionGroup",
    width: "30%",
  },
  {
    title: (
      <p
        style={{
          margin: 0,
          fontWeight: 600,
          fontSize: 15,
        }}
      >
        Manage
      </p>
    ),
    key: "action",
    width: "10%",
    render: (data: any, user: any) => <ActionColumn user={user} />,
  },
];

export const PENDING_INVITATIONS_COLUMNS = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    width: "25%",
    sorter: (a: any, b: any) => ("" + a.name).localeCompare(b.name),
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
    width: "30%",
    sorter: (a: any, b: any) => ("" + a.email).localeCompare(b.email),
  },
  {
    title: "Invite Date",
    dataIndex: "inviteDate",
    key: "inviteDate",
    width: "25%",
    render: (data: any) => {
      const date = new Date(data);
      const expirationDate = new Date(
        date.getTime() + 90 * 24 * 60 * 60 * 1000
      );
      const currentDate = new Date();
      const isExpired = currentDate.getTime() > expirationDate.getTime();
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <p
            style={{
              margin: 0,
              fontWeight: 500,
              fontSize: 15,
            }}
          >
            {data}
          </p>
          {isExpired ? (
            <div
              style={{
                marginTop: 10,
                marginLeft: 5,
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                // xmlns:xlink="http://www.w3.org/1999/xlink"
                width="25"
                zoomAndPan="magnify"
                viewBox="0 0 810 809.999993"
                height="25"
                preserveAspectRatio="xMidYMid meet"
                version="1.0"
              >
                <defs>
                  <clipPath id="9ff4460538">
                    <path
                      d="M 213 290 L 699 290 L 699 704.800781 L 213 704.800781 Z M 213 290 "
                      clip-rule="nonzero"
                    />
                  </clipPath>
                  <clipPath id="1e7e25f318">
                    <path
                      d="M 98 105.550781 L 466 105.550781 L 466 475 L 98 475 Z M 98 105.550781 "
                      clip-rule="nonzero"
                    />
                  </clipPath>
                </defs>
                <path
                  fill="#000000"
                  d="M 282.996094 292.238281 C 273.78125 292.238281 264.5625 287.628906 266.867188 280.714844 L 271.476562 183.914062 C 271.476562 179.304688 273.78125 174.695312 282.996094 174.695312 C 289.910156 174.695312 294.519531 179.304688 294.519531 183.914062 L 301.433594 280.714844 C 301.433594 287.628906 292.214844 292.238281 282.996094 292.238281 Z M 282.996094 292.238281 "
                  fill-opacity="1"
                  fill-rule="nonzero"
                />
                <path
                  fill="#000000"
                  d="M 303.738281 294.546875 L 241.519531 349.859375 C 239.214844 352.164062 232.300781 354.46875 225.386719 347.554688 C 218.472656 340.640625 220.777344 333.726562 223.082031 331.421875 L 276.085938 269.191406 C 280.695312 264.582031 308.347656 289.933594 303.738281 294.546875 Z M 303.738281 294.546875 "
                  fill-opacity="1"
                  fill-rule="nonzero"
                />
                <path
                  fill="#000000"
                  d="M 310.652344 289.933594 C 310.652344 290.839844 310.605469 291.746094 310.519531 292.644531 C 310.429688 293.546875 310.296875 294.441406 310.121094 295.332031 C 309.941406 296.21875 309.722656 297.097656 309.460938 297.964844 C 309.199219 298.832031 308.894531 299.683594 308.546875 300.519531 C 308.199219 301.355469 307.8125 302.175781 307.386719 302.972656 C 306.960938 303.773438 306.492188 304.546875 305.992188 305.300781 C 305.488281 306.054688 304.949219 306.78125 304.375 307.480469 C 303.800781 308.179688 303.191406 308.851562 302.550781 309.492188 C 301.910156 310.132812 301.242188 310.742188 300.539062 311.316406 C 299.839844 311.890625 299.113281 312.429688 298.359375 312.933594 C 297.609375 313.433594 296.832031 313.898438 296.035156 314.328125 C 295.234375 314.753906 294.417969 315.140625 293.582031 315.488281 C 292.742188 315.835938 291.890625 316.140625 291.023438 316.402344 C 290.160156 316.664062 289.28125 316.886719 288.394531 317.0625 C 287.503906 317.238281 286.609375 317.371094 285.707031 317.460938 C 284.808594 317.546875 283.902344 317.59375 282.996094 317.59375 C 282.09375 317.59375 281.1875 317.546875 280.289062 317.460938 C 279.386719 317.371094 278.492188 317.238281 277.601562 317.0625 C 276.714844 316.886719 275.835938 316.664062 274.96875 316.402344 C 274.105469 316.140625 273.253906 315.835938 272.414062 315.488281 C 271.578125 315.140625 270.761719 314.753906 269.960938 314.328125 C 269.164062 313.898438 268.386719 313.433594 267.632812 312.933594 C 266.882812 312.429688 266.15625 311.890625 265.453125 311.316406 C 264.753906 310.742188 264.085938 310.132812 263.445312 309.492188 C 262.804688 308.851562 262.195312 308.179688 261.621094 307.480469 C 261.046875 306.78125 260.507812 306.054688 260.003906 305.300781 C 259.5 304.546875 259.035156 303.773438 258.609375 302.972656 C 258.183594 302.175781 257.796875 301.355469 257.449219 300.519531 C 257.101562 299.683594 256.796875 298.832031 256.535156 297.964844 C 256.273438 297.097656 256.050781 296.21875 255.875 295.332031 C 255.699219 294.441406 255.566406 293.546875 255.476562 292.644531 C 255.390625 291.746094 255.34375 290.839844 255.34375 289.933594 C 255.34375 289.03125 255.390625 288.125 255.476562 287.222656 C 255.566406 286.324219 255.699219 285.429688 255.875 284.539062 C 256.050781 283.652344 256.273438 282.773438 256.535156 281.90625 C 256.796875 281.039062 257.101562 280.1875 257.449219 279.351562 C 257.796875 278.515625 258.183594 277.695312 258.609375 276.898438 C 259.035156 276.097656 259.5 275.324219 260.003906 274.570312 C 260.507812 273.816406 261.046875 273.089844 261.621094 272.390625 C 262.195312 271.6875 262.804688 271.019531 263.445312 270.378906 C 264.085938 269.738281 264.753906 269.128906 265.453125 268.554688 C 266.15625 267.980469 266.882812 267.441406 267.632812 266.9375 C 268.386719 266.4375 269.164062 265.96875 269.960938 265.542969 C 270.761719 265.117188 271.578125 264.730469 272.414062 264.382812 C 273.253906 264.035156 274.105469 263.730469 274.96875 263.46875 C 275.835938 263.207031 276.714844 262.984375 277.601562 262.808594 C 278.492188 262.632812 279.386719 262.5 280.289062 262.410156 C 281.1875 262.320312 282.09375 262.277344 282.996094 262.277344 C 283.902344 262.277344 284.808594 262.320312 285.707031 262.410156 C 286.609375 262.5 287.503906 262.632812 288.394531 262.808594 C 289.28125 262.984375 290.160156 263.207031 291.023438 263.46875 C 291.890625 263.730469 292.742188 264.035156 293.582031 264.382812 C 294.417969 264.730469 295.234375 265.117188 296.035156 265.542969 C 296.832031 265.96875 297.609375 266.4375 298.359375 266.9375 C 299.113281 267.441406 299.839844 267.980469 300.539062 268.554688 C 301.242188 269.128906 301.910156 269.738281 302.550781 270.378906 C 303.191406 271.019531 303.800781 271.6875 304.375 272.390625 C 304.949219 273.089844 305.488281 273.816406 305.992188 274.570312 C 306.492188 275.324219 306.960938 276.097656 307.386719 276.898438 C 307.8125 277.695312 308.199219 278.515625 308.546875 279.351562 C 308.894531 280.1875 309.199219 281.039062 309.460938 281.90625 C 309.722656 282.773438 309.941406 283.652344 310.121094 284.539062 C 310.296875 285.429688 310.429688 286.324219 310.519531 287.222656 C 310.605469 288.125 310.652344 289.03125 310.652344 289.933594 Z M 310.652344 289.933594 "
                  fill-opacity="1"
                  fill-rule="nonzero"
                />
                <g clip-path="url(#9ff4460538)">
                  <path
                    fill="#000000"
                    d="M 688.582031 635.65625 L 497.3125 319.898438 C 474.265625 280.714844 435.089844 280.714844 412.046875 319.898438 L 223.082031 635.65625 C 200.039062 674.839844 218.472656 704.800781 264.5625 704.800781 L 644.796875 704.800781 C 693.191406 704.800781 711.625 672.535156 688.582031 635.65625 Z M 430.484375 407.480469 C 437.394531 400.566406 446.613281 395.957031 455.832031 395.957031 C 467.355469 395.957031 474.265625 400.566406 481.179688 407.480469 C 488.09375 414.394531 490.398438 423.613281 490.398438 432.832031 C 490.398438 442.050781 476.570312 508.890625 471.964844 557.292969 L 437.394531 557.292969 C 432.789062 508.890625 418.960938 442.050781 418.960938 432.832031 C 418.960938 423.613281 423.570312 414.394531 430.484375 407.480469 Z M 481.179688 637.960938 C 474.265625 644.875 465.050781 647.179688 455.832031 647.179688 C 446.613281 647.179688 437.394531 644.875 430.484375 637.960938 C 423.570312 631.046875 418.960938 624.132812 418.960938 612.609375 C 418.960938 603.390625 423.570312 594.171875 430.484375 587.253906 C 437.394531 580.339844 446.613281 578.035156 455.832031 578.035156 C 465.050781 578.035156 474.265625 580.339844 481.179688 587.253906 C 488.09375 594.171875 492.703125 603.390625 492.703125 612.609375 C 492.703125 624.132812 488.09375 631.046875 481.179688 637.960938 Z M 481.179688 637.960938 "
                    fill-opacity="1"
                    fill-rule="nonzero"
                  />
                </g>
                <g clip-path="url(#1e7e25f318)">
                  <path
                    fill="#000000"
                    d="M 294.519531 474.320312 L 326.78125 421.308594 C 310.652344 425.917969 296.824219 428.222656 282.996094 428.222656 C 206.949219 428.222656 144.730469 365.992188 144.730469 289.933594 C 144.730469 213.875 206.949219 151.648438 282.996094 151.648438 C 354.4375 151.648438 414.351562 206.960938 421.265625 278.410156 C 430.484375 271.496094 444.308594 266.886719 455.832031 266.886719 C 458.136719 266.886719 462.746094 266.886719 465.050781 266.886719 C 453.527344 174.695312 375.175781 105.550781 282.996094 105.550781 C 181.601562 105.550781 98.640625 188.523438 98.640625 289.933594 C 98.640625 391.347656 181.601562 474.320312 282.996094 474.320312 C 287.605469 474.320312 289.910156 474.320312 294.519531 474.320312 Z M 294.519531 474.320312 "
                    fill-opacity="1"
                    fill-rule="nonzero"
                  />
                </g>
              </svg>
            </div>
          ) : null}
        </div>
      );
    },
  },
  // {
  //   title: "Expired",
  //   dataIndex: "expired",
  //   key: "expired",
  //   width: "15%",
  // },
  {
    title: "Action",
    key: "action",
    width: "10%",
    render: (data: any, user: any) => <ActionColumn user={user} />,
  },
];

export const FAILED_INVITATIONS_COLUMNS = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    width: "25%",
    sorter: (a: any, b: any) => ("" + a.name).localeCompare(b.name),
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
    width: "40%",
    sorter: (a: any, b: any) => ("" + a.email).localeCompare(b.email),
  },
  {
    title: "Expired On",
    dataIndex: "expiredOn",
    key: "expiredOn",
    width: "25%",
  },
  {
    title: "Action",
    key: "action",
    width: "15%",
    render: (data: any, user: any) => <ActionColumn user={user} />,
  },
];
